import { setOptions } from '@googlemaps/js-api-loader';

export const googleMapsLoader = (apiKey: string) => {
  return setOptions({
    key: apiKey,
    v: 'weekly',
  });
};
